<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <h1>Настройки</h1>
    </v-col>
    <v-col cols="12" sm="12">
      <v-checkbox v-model="isMobileOrderDirect.value" label="Заказы с мобилки напрямую" @click="updateIsMobileOrderDirect"></v-checkbox>
      <v-checkbox v-model="isOffTimeSelects.value" label="Выключить выбор доставки на точное время" @click="updateIsOffTimeSelects"></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import SettingService from './../../api/SettingService'
  export default {
    name: 'SettingIndex',
    components: {},
    data: () => ({
      isMobileOrderDirect: {},
      isOffTimeSelects: {}
    }),
    mounted() {
        SettingService.get('is_mobile_order_direct').then(response => {
            this.isMobileOrderDirect = response.data
            if(this.isMobileOrderDirect.value == "true"){
                this.isMobileOrderDirect.value = true
            } else {
                this.isMobileOrderDirect.value = false
            }
        });

      SettingService.get('is_off_time_selects').then(response => {
        this.isOffTimeSelects = response.data
        if(this.isOffTimeSelects.value == "true"){
          this.isOffTimeSelects.value = true
        } else {
          this.isOffTimeSelects.value = false
        }
      });
    },
    watch: {

    },
    methods: {
        updateIsMobileOrderDirect(){
            SettingService.update(this.isMobileOrderDirect.id, {value: this.isMobileOrderDirect.value})
        },
      updateIsOffTimeSelects(){
          SettingService.update(this.isOffTimeSelects.id, {value: this.isOffTimeSelects.value})
        },
    }
  }
</script>

<style lang="scss" scoped>
</style>
